import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { DialogLookupUsersGroupsComponent } from 'src/app/+home/shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component';
import { User } from 'src/shared/models/user.class';
import { BoardService } from 'src/shared/services/board.service';

@Component({
  selector: 'app-board-item',
  templateUrl: './board-item.component.html',
  styleUrls: ['./board-item.component.scss'],
})
export class BoardItemComponent implements OnInit {
  @Input() item;
  @Input() kanbanId;
  @Input() columnId
  @Output() emitText: EventEmitter<{ id: number; text: string }> = new EventEmitter();
  @Output() emitCardItem: EventEmitter<{ card: any; increase: boolean }> = new EventEmitter();
  @Output() emitAffectto: EventEmitter<{affectto,email}> = new EventEmitter();
  @Output() emitDeleteCard: EventEmitter<number> = new EventEmitter();
  @Output() emitEditTask: EventEmitter<{title; description, dueDate, onEdit}> = new EventEmitter();
  @Output() emitSeeDocument = new EventEmitter();
  @Output() emitCloture = new EventEmitter();
  @Output() emitOpen = new EventEmitter();
  @Output() emitSelectFile = new EventEmitter();
  @Output() emitSeeFile = new EventEmitter();
  @Output() emitRemoveFile = new EventEmitter();
  @Output() emitLabel = new EventEmitter();


  commentInput = ''
  open = false;
  mySet = [];
  onEdit = false
  affect = false;
  affectto: any[] = [];
  fileInput: any;
  kanbanTitle: any;
  constructor(private dialog: MatDialog,    
    public boardService: BoardService,
    ) { }

  ngOnInit(){
    this.onEdit = false
  }


  onOpenComment() {
    this.open = !this.open
  }

  affectTo(){
    this.affect = !this.affect
    const dialogRef = this.dialog.open(DialogLookupUsersGroupsComponent, {
      width: '60%',
      height: '45%',
      data:{
        permission: true,
        affect: this.item.affectto,
        kanbanid: this.kanbanId,
        columnid: this.columnId,
        itemid: this.item,
        mySet: this.mySet

      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.boardService.getKanban(this.kanbanId).toPromise().then((res) => this.kanbanTitle = res.title)
      this.boardService.addAffect(result.affect, result.mail, this.kanbanId, this.columnId, this.item, this.kanbanTitle)
      .toPromise()
      .then()
        this.ngOnInit()
        // window.location.reload()

    });
  }

  onSeeDocument(document) {
    this.emitSeeDocument.emit({ document });
  }

  onCloture(id){
    this.emitCloture.emit(id)
  }

  onSeeFile(base64){
        this.emitSeeFile.emit(base64)
  }

  onSelectFile(event){
    this.emitSelectFile.emit(event)
  }

  onLabelClick(){
    this.emitLabel.emit(this.item)
  }

  onOpen(id){
    this.emitOpen.emit(id)
  }

  onEditTask($event){
    this.emitEditTask.emit({title: $event.title, description: $event.description, dueDate: $event.dueDate, onEdit: true})
  }

  onCommentTextEmit(id: number) {
    this.emitText.emit({ id, text: this.commentInput });
    this.commentInput = ''
  }

  onCardItemEmit(card: any, increase: boolean) {
    this.emitCardItem.emit({ card, increase });
  }

  onCardDelete(id: number) {
    this.emitDeleteCard.emit(id)
  }

  onRemoveFile(id){
    this.emitRemoveFile.emit(id)
  }
}
